import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core'

/**
 * A chip component for displaying a label with an optional action icon.
 */
@Component({
    selector: 'fbr-chip',
    templateUrl: './chip.component.html',
    styleUrls: ['./chip.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ChipComponent {
    @Input() icon: string
    @Input() invert = false

    // if set, the chip will have an auto-generated background color based on the string value passed in.
    @Input() colorFrom = ''

    @Input() className = ''
    @Input() colorType: 'error' | 'success' | 'warning'
    @Input() tooltip = ''

    @Output() iconClick = new EventEmitter<MouseEvent>()
}
